import React from 'react';
import styled, { css } from 'styled-components';

const Input = styled.textarea`
  width: 100%;
  height: 12rem;
  padding: 0.8rem 1.2rem;
  display: block;
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && css`
    width: ${theme.form.textarea.width || '100%'};
    height: ${theme.form.textarea.height || '12rem'};
    padding: ${theme.form.textarea.padding || '0.8rem 1.2rem'};
    border: ${theme.form.textarea.border || '1px solid #ced4da'};
    border-radius: ${theme.form.textarea.borderRadius || '0.25rem'};
    
    &:hover {
      border: ${theme.form.input?.hover?.border || '1px black solid'};
    }
    
    &:focus {
      outline: ${theme.form.input?.focus?.outline || 'none'};
      border-color: ${theme.form.input?.focus?.borderColor || '#80bdff'};
      box-shadow: ${theme.form.input?.focus?.boxShadow || '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'};
    }
    
    &:disabled {
      cursor: default;
      background: ${theme.form.input?.disabled?.background || '#555'};
    }
  `}
`;

export const TextArea = (props) => <Input {...props} />;

export default TextArea;

